// One queued save in the sync sheet/page: verb, title, project, photos, a few field lines.
import React from "react";
import _ from "lodash";
import moment from "moment";
import { ListItem, Badge } from "framework7-react";

export const syncSummary = (items) => {
  const creates = _.filter(items, { verb: "Create" }).length;
  const updates = _.filter(items, { verb: "Update" }).length;
  const deletes = _.filter(items, { verb: "Delete" }).length;
  const photos = _.sumBy(items, "photoCount") || 0;
  const parts = [];
  if (creates) parts.push(`${creates} new`);
  if (updates) parts.push(`${updates} update${updates === 1 ? "" : "s"}`);
  if (deletes) parts.push(`${deletes} delete${deletes === 1 ? "" : "s"}`);
  if (photos) parts.push(`${photos} photo${photos === 1 ? "" : "s"}`);
  return parts.join(" · ");
};

const PendingSyncItem = ({ item, projectName, link }) => {
  const when = item.createdAt ? moment(item.createdAt).format("DD/MM HH:mm") : "";
  const title = item.verb === "Switch" ? projectName || item.title : item.title;
  const meta = _.compact([
    item.verb === "Switch" ? null : projectName,
    item.photoCount > 0 ? `${item.photoCount} photo${item.photoCount === 1 ? "" : "s"}` : null,
    when && `Saved ${when}`,
  ]).join(" · ");

  const previewLines = _.map(item.highlights, (h) => `${h.label}: ${h.value}`).join(" · ");
  const footer = _.compact([previewLines, meta, item.lastError]).join("\n");

  return (
    <ListItem title={`${item.verb} ${item.kind}`} subtitle={title || undefined} footer={footer || undefined} link={link}>
      <Badge slot="after" color={item.status === "failed" ? "red" : "orange"}>
        {item.status === "failed" ? "Failed" : "Waiting"}
      </Badge>
    </ListItem>
  );
};

export default PendingSyncItem;
